<template>
  <div class="banner-upgrade-container">
    <div class="banner-upgrade-wrapper">
      <div class="banner-upgrade-icone">
        <div>
          <font-awesome-icon icon="bolt" />
        </div>
      </div>
      <div class="banner-upgrade-fecha" @click="toggleBanner">
        <font-awesome-icon icon="times-circle" />
      </div>
      <h1>CONHEÇA NOSSAS VERSÕES PREMIUM DO RTE!</h1>
      <div class="banner-upgrade-vantagens">
        <div class="banner-upgrade-vantagens-item" v-for="(item, index) in vantagens" :key="index">
          <div>
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="banner-upgrade-botao" @click="abreLinkUpgrade">ACESSE COM FORÇA MÁXIMA!</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BannerUpgrade",
  props: {
    toggleBanner: Function
  },
  data() {
    return {
      vantagens: [
        "● Aumente a capacidade de pesquisa de NCMs",
        "● Cadastre mais empresas",
        "● Cadastre mais produtos",
        "● Amplie o monitoramento tributário dos produtos"
      ]
    };
  },
  computed: {
    ...mapGetters("login", ["getUser"])
  },
  methods: {
    abreLinkUpgrade() {
      const link = "https://carrinho.econeteditora.com.br/";
      window.open(link, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-upgrade-container {
  width: 100%;
  padding: 0 15px;
  color: var(--branco);
  margin: 15px 0;
  user-select: none;
}
.banner-upgrade-wrapper {
  position: relative;
  background: var(--azul4);
  margin-top: 40px;
  padding: 15px;
  border-radius: 10px 10px 0 0;
  box-shadow: 2px 2px 4px var(--sombra1);
  h1 {
    text-align: center;
    font-size: 23px;
    font-family: "Roboto Condensed";
    font-weight: 700;
    margin: 0 80px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px dashed var(--branco);
  }
}
.banner-upgrade-icone {
  position: absolute;
  top: -50px;
  left: 30px;
  font-size: 80px;
  filter: drop-shadow(4px -4px 0px var(--azul4));
  > div {
    position: relative;
  }
}
.bolt-sombra {
  position: absolute;
  color: var(--azul4);
  left: -1px;
  bottom: 11px;
  font-size: 95px;
  z-index: -1;
}
.banner-upgrade-fecha {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 18px;
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.banner-upgrade-vantagens {
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-family: "Roboto Condensed";
  font-size: 16px;
  margin: 0 30px;
  gap: 5px 0;
}
.banner-upgrade-vantagens-item {
  display: flex;
  justify-content: center;
  width: 100%;
  > div {
    width: 350px;
    max-width: 100%;
  }
}
.banner-upgrade-botao {
  background: var(--azul3);
  border-radius: 0 0 10px 10px;
  padding: 10px;
  font-family: "Roboto Condensed";
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  box-shadow: 2px 2px 4px var(--sombra1);
}
@media (max-width: 800px) {
  .banner-upgrade-vantagens {
    display: flex;
    flex-direction: column;
    margin: 0 20px;
  }
  .banner-upgrade-vantagens-item {
    width: auto !important;
    justify-content: flex-start;
    > div {
      width: auto;
      max-width: none;
    }
  }

  .banner-upgrade-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    h1 {
      max-width: 300px;
    }
  }
}
@media (max-width: 500px) {
  .banner-upgrade-vantagens {
    font-size: 13px;
  }

  .banner-upgrade-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    h1 {
      margin: 0 60px 10px 60px;
      max-width: 300px;
      font-size: 15px;
    }
  }
  .banner-upgrade-icone {
    top: -35px;
    left: 30px;
    font-size: 60px;
  }
}
</style>
